const dataScreenEn = {
  //默认大屏
  scDefaultLang: {
    电站指标: 'Power station index',
    个: '',
    电站总数: 'Total number of power stations',
    年1: 'year',
    年2: 'years',
    天: 'days',
    安全运行时间: 'Safe operating time',
    总装机功率: 'Total installed power',
    总装机容量: 'Installed gross capacity',
    电量趋势: 'Energy trend',
    大屏总充电量: 'Total charge',
    大屏总放电量: 'Total discharge',
    社会公益: 'Social Welfare',
    'CO2减排(吨)': 'CO2 reduction (tons)',
    '节约标准煤(吨)': 'Saving standard coal (tons)',
    '等效植树量(棵)': 'Equivalent planting amount (tree)',
    '累计收益/元': 'Cumulative income',
    收益指标: 'Revenue target',
    '当日/元': 'Today',
    '当月/万元': 'Monthly/K',
    收益趋势: 'Return trend',
    近7日: 'Last 7 days',
    近31日: 'Last 31 days',
    近12月: 'Last 12 months',
    收益排行: 'Revenue ranking',
    星期日: 'Sunday',
    星期一: 'Monday',
    星期二: 'Tuesday',
    星期三: 'Wednesday',
    星期四: 'Thursday',
    星期五: 'Friday',
    星期六: 'Saturday',
    智慧储能数据云平台: 'Intelligent storage data cloud platform',

    返回: 'Return',
    累计收益: 'Cumulative income',
    万元: 'K',
    大屏总充电: 'Total charge',
    大屏总放电: 'Total discharge',
    装机容量: 'Installed capacity',
    装机功率: 'Installed power',
    电站地址: 'Address',
    收益: 'Income',
    充电量: 'Charge capacity',
    放电量: 'Discharge capacity'
  },
  //华友大屏
  scHyLang: {
    电量指标: 'Electric quantity index',
    大屏总充电量: 'Total charge',
    大屏总放电量: 'Total discharge',
    电量趋势: 'Energy trend',
    电站安全: 'Power station safety',
    '安全运行时间(天)': 'Safe operating time (days)',
    '电站总数(个)': 'Total number of power stations (units)',
    总装机功率: 'Total installed power',
    总装机容量: 'Installed gross capacity',
    收益指标: 'Revenue target',
    '累计收益/万元': 'Cumulative income/K',
    '今日收益/元': 'Today＇s revenue',
    收益趋势: 'Return trend',
    按日: 'Daily',
    按周: 'Weekly',
    按月: 'Monthly',
    排名: 'Ranking',
    'CO2减排(吨)': 'CO2 reduction (tons)',
    '节约标准煤(吨)': 'Saving standard coal (tons)',
    '等效植树量(棵)': 'Equivalent planting amount (tree)',
    星期日: 'Sunday',
    星期一: 'Monday',
    星期二: 'Tuesday',
    星期三: 'Wednesday',
    星期四: 'Thursday',
    星期五: 'Friday',
    星期六: 'Saturday',

    单位: '',
    '单位/万元': 'Unit/K',
    万元: 'K',
    收益: 'Income',
    充电量: 'Charge capacity',
    放电量: 'Discharge capacity',
    返回: 'Return'
  }
}
export default dataScreenEn
